// extracted by mini-css-extract-plugin
export default {"internalRemark":"src-pages-Order-Components-InternalRemark-css-module__internalRemark--8MK9E"};